import axios from 'axios';
import { handleShellSessionExpiry } from '@/shells/services/sessionExpiry';

const shellHttpClient = axios.create({
  baseURL: process.env.VUE_APP_API || '',
  timeout: 15000,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
});

shellHttpClient.interceptors.request.use(config => {
  const token = localStorage.getItem('user_access_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
});

shellHttpClient.interceptors.response.use(
  response => response,
  error => {
    handleShellSessionExpiry(error && error.response && error.response.status);
    return Promise.reject(error);
  }
);

export default shellHttpClient;
